import localForage from 'localforage';
import { persistReducer } from 'redux-persist';
import { createSelector } from '@reduxjs/toolkit';
import { type RootState } from 'app/store';
import { type RolesState, type RolesActionTypes } from 'app/store/types';

const initialState: RolesState = {};

const rolesReducer = (state = initialState, action: RolesActionTypes) => {
	switch (action.type) {
		case 'GET_LICENSE_GROUP_DATA_SUCCESS': {
			const {
				licenseGroupId,
				data: { roles },
			} = action.payload;

			return {
				...state,
				[licenseGroupId]: {
					...state[licenseGroupId],
					...(roles && { byId: roles }),
				},
			};
		}
		case 'LOGGED_OUT_USER':
		case 'PURGE_STATE':
			return initialState;
		default: {
			return state;
		}
	}
};

export default persistReducer(
	{
		key: 'roles',
		storage: localForage,
		whitelist: localStorage.getItem('persist') ? undefined : [],
	},
	rolesReducer,
);

// Selectors
export const getRolesById = ({ app: { selectedLicenseGroupId }, roles }: RootState) =>
	roles[selectedLicenseGroupId].byId;

export const getRoles = createSelector([getRolesById], (rolesById) => Object.values(rolesById));
